export class CustomerInstanceVenueData {
    public static readonly DEPLOYMENT_STATUS_PENDING = "PENDING";
    public static readonly DEPLOYMENT_STATUS_READY = "READY";
    public static readonly DEPLOYMENT_STATUS_CHURNED = "CHURNED";

    id: string;
    name: string;
    salesRep: string;
    partner: string;
    signUpUrlSentDate: string;
    instanceId: string;
    draft: boolean;
    deploymentStatus: string;
    discontinued: boolean;
}
